




















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import TableBasedView from "@/components/TableBasedView.vue"
import {UtmUrl} from "@/Models"
import Rules from "@/Rules"

@Component({
  components: {TableBasedView}
})
export default class UtmUrls extends Vue {

  headers = [
    {text: 'Name', align: 'start', sortable: true, value: 'name', width: '25%'},
    {text: 'Query String', align: 'start', sortable: false, value: 'value', width: '75%'},
    {text: 'Actions', align: 'center', value: 'actions', sortable: false}
  ]

  defaultItem = new UtmUrl()
  rules = new Rules()

}
